<div class="in-page-navbar d-flex" [ngClass]="navItems.length > 6 ? 'justify-content-between' : 'justify-content-start'" >
    @for (item of navItems; track item;) {
    <div class="d-flex nav" [routerLink]="item.route" [ngClass]="navItems.length > 6 ? '' : 'me-5'">
        <div class="in-page-navbar-icon" [ngClass]="item.customClass">
            <mwp-svg-icon [SvgMatType]="item.icon" [SvgColor]="svgColor.buttonWithBackground" />
        </div>
        <div class="px-2 align-content-center">
            <mwp-text-translate [text]=item.label [jsonKey]=item.key />
        </div>
    </div>
    }
</div>

